module.exports = __webpack_public_path__ + "32bcd8d2ca530aa7a746ac1be5cc231a.pdf";